import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import CookieSettingPopup from "../../components/popup/CookieSettingPopup";
import NoItem from "../../assets/images/products/haier-no-item.svg";
import { useLiff } from "react-liff";
import edit from "../../assets/images/icon/edit.svg";
import TopLogo from "../../components/layout/TopLogo";
import TopBanner from "../../components/layout/TopBanner";
import TopBtn from "../../components/layout/TopBtnMember";
import { SearchMemberProfile } from "../../services/Member";
import { setMember } from "../../features/MemberSlice";
import useWindowDimensions from "../../functions/getScreen";
import { SearchProduct } from "../../services/Product";
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import TransparentButton from "../../components/button/TransparentButton";

export default function UserProducts() {

  const { height } = useWindowDimensions();

  const [memberId, setMemberId] = useState(null);
  const [productList, setProductList] = React.useState([]);

  const [loadMore, setLoadmore] = React.useState({
    limit: 100,
    offset: 0,
    total: 0
  });

  const [count, setCount] = React.useState(0);

  const [isLoading, setIsLoading] = React.useState(false);


  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();


  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  React.useEffect(() => {
    getSearchMemberProfile();
  }, []);

  async function getSearchMemberProfile() {
    return await SearchMemberProfile({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        }
        else {
          if (response.data.body.memberCode) {
            setMemberId(response.data.body.id)
            fnSetData('memberId', response.data.body.id)
            getSearchProduct(response.data.body.id)
          } else {
            navigate("/register");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchProduct(member) {
    const { offset, limit } = loadMore
    return await SearchProduct({ data: { memberId: member, limit: limit, offset: offset } })
      .then(async (response) => {
        let tmp = null
        let tmp2 = null
        if (+response.data.resultCode === 20000) {
          let resData = response.data.body
          resData = resData.map(item => {
            item.isActive = false
            return item
          })
          tmp = [...productList, ...resData]
          // tmp2 = 11
          setProductList(tmp)
          // setCount(tmp2)
        } else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  React.useEffect(() => {
  }, [productList]);



  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setMember(tmpObj));
  }

  const goToAdd = () => {
    navigate("/add-products", {
      state: {
        memberId: memberId,
      },
    });
  };

  function ItemListScan() {
    const onActive = (i) => {
      let tmp = [...productList]
      tmp[i].isActive = true
      setProductList(tmp)
    }
    return (
      <div>
        {productList.map((item, index) => (
          <div key={index}>
            <div className="grid h-[87px] w-full bg-white mb-[20px] rounded-[6px]">
              <div className="grid h-full" style={{ gridTemplateColumns: "4fr 3fr" }}>
                <div className="my-auto ml-[20px] leading-[18px]">
                  <p className="text-lightBlue2 text-[16px] font-bold">{item.warrantyName}</p>
                  <p className="text-lightBlue2 text-[20px] font-bold">{item.code}</p>
                  <p className="text-gray text-[14px]">{item.modelName}</p>
                </div>
                <div className="h-fit m-auto">
                  <SecondaryButtonSmall
                    variant="outlined"
                    className="w-[106px]"
                    onClick={() => navigate('/products-detail', { state: { memberId: memberId, productId: item.id } })}>
                    ดูรายละเอียด
                  </SecondaryButtonSmall>
                </div>
              </div>
            </div>
          </div>
        ))
        }
      </div>
    )
  }

  useEffect(() => {
    if (memberId) {
      if (loadMore.offset > 0 && count >= loadMore.total) {
        getSearchProduct(memberId, true)
      }
    }
  }, [loadMore])

  return (
    <div style={{ backgroundColor: "#FFFFFF" }} id="shop-page">
      <TopLogo />
      <TopBanner type="product" />
      <CookieSettingPopup
        open={openCookiePopup}
        onClose={() => {
          setOpenCookiePopup(false);
        }}
      />
      <div
        id="shop"
        className="bg-white mt-[-40px] px-[20px]"
      >
        <div className="relative">
          <TopBtn type="product"></TopBtn>
        </div>
      </div>
      <div className="bg-white mt-[-25px] px-[0px]">
        <div className="p-[16px]">
          <div className="flex gap-[10px] justify-start px-[20px]">
            <div className="primary-color title-size">สินค้า</div>
            <div style={{ marginTop: "6px" }}>
              <p className="sub-title-size"> Product Warranty Card {productList.lenght}</p>
              <div className="blue-line"></div>
            </div>
          </div>
        </div>
        {productList.length > 0 ? (
          <div className="p-[25px] overflow-y-auto" style={{ backgroundColor: "#005AAA", height: 'calc(100vh - 445px)' }}>
            {ItemListScan()}
          </div>
        ) : (
          <div style={{ height: `${height - 445}px` }}>
            <div
              className="h-[100%] content-user-products"
              style={{
                backgroundColor: "#005AAA",
              }}
            >
              <img
                className="m-auto"
                src={NoItem}
                alt="logo"
                style={{
                  width: "30%",
                  alignItems: "center",
                  opacity: "0.30000001192092896",
                  mixBlendMode: "luminosity",
                }}
              />
            </div>

          </div>
        )}

        <div className="bt-product bg-white w-full fixed bottom-0">
          <button
            onClick={goToAdd}
            className="bt-add-product mt-[20px] mb-[20px]  w-full "
          >
            <p className=" text-[20px]">ลงทะเบียนสินค้า</p>
          </button>
        </div>
      </div>
    </div> 
    // <div className="leading-[34px] text-[34px] no-event text-white text-center">
    //   <p className="mb-[200px]">
    //     พบกันเร็ว ๆ นี้
    //   </p>
    //   <TransparentButton
    //     className="w-[80%]"
    //     variant="outlined"
    //     onClick={() => liff.closeWindow()}
    //   >
    //     <p>ย้อนกลับ</p>
    //   </TransparentButton>
    // </div>
  );
}
